import { FC } from "react";

import { useTheme } from "app/shared";
import styles from "./dashboard-footer.module.scss";

const DashboardFooter: FC = () => {
  const { theme } = useTheme();

  return (
    <div
      className={`${styles.footer} ${theme === "dark" ? styles.darkTheme : ""}`}
    >
      <div className={styles.content}>
        <p className={styles.disclaimer}>
          AlphaMind is a platform for blockchain project discovery &
          participation. All the content is intended for educational and
          informational purposes only. We strongly encourage to conduct thorough
          research (DYOR) before making any decisions. Please note that
          AlphaMind does not provide financial advice, guarantee profits, or
          assume any liability for project participation outcomes.
        </p>
      </div>
    </div>
  );
};

export default DashboardFooter;
